import VueRouter from "vue-router";

// 自动引入 modules 目录下所有路由
const importAll = (r) =>
  r.keys().reduce((routes, key) => routes.concat(r(key).default), []);

const routes = importAll(require.context("./modules", true, /\.js$/));
export const router = new VueRouter({
  routes,
  mode: "history",
});

router.beforeEach((from, to, next) => {
  if (from.meta.title) {
    document.title = from.meta.title;
  }

  next();
});
